import { useWarnWhenUnsavedChanges } from './useWarnWhenUnsavedChanges';
export var WarnWhenUnsavedChanges = function (_a) {
    var _b = _a.enable, enable = _b === void 0 ? true : _b, formRootPathName = _a.formRootPathName, formControl = _a.formControl;
    useWarnWhenUnsavedChanges(enable, formRootPathName, formControl);
    return null;
};
//# sourceMappingURL=WarnWhenUnsavedChanges.js.map